import React from "react";
import { useStaticQuery, graphql } from "gatsby";
import locales from "../utility/locales";

function Seo({
  description,
  langCode = `it-IT`,
  canonical,
  ogImage,
  meta = [],
  keywords = [],
  robots,
  skipEn,
  title = "",
}) {
  const { site } = useStaticQuery(
    graphql`
      query DefaultSEOQuery {
        site {
          siteMetadata {
            title
            description
          }
        }
      }
    `
  );

  const metaDescription = description || site.siteMetadata.description;
  const lang = locales[langCode].lang;

  return (
    <>
      <html lang={lang} />
      <title>{title}</title>
      <meta name="description" content={metaDescription} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={metaDescription} />
      <meta property="og:type" content="website" />
      <meta name="twitter:card" content="summary" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={metaDescription} />
      {ogImage?.node?.resize && (
        <>
          <meta property="og:image" content={ogImage.node.resize.src} />
          <meta property="og:image:width" content={ogImage.node.resize.width} />
          <meta
            property="og:image:height"
            content={ogImage.node.resize.height}
          />
          <meta name="twitter:image" content={ogImage.node.resize.src} />
          <meta
            name="twitter:image:width"
            content={ogImage.node.resize.width}
          />
          <meta
            name="twitter:image:height"
            content={ogImage.node.resize.height}
          />
        </>
      )}
      {keywords.length > 0 && (
        <meta name="keywords" content={keywords.join(", ")} />
      )}
      <meta
        name="robots"
        value={
          skipEn && langCode === "en-US"
            ? "none"
            : robots
            ? robots.join(", ")
            : "index,follow"
        }
      />
      {canonical && <link rel="canonical" href={canonical} />}
    </>
  );
}

export default Seo;
export const seoPaginaTitleFragment = graphql`
  fragment PaginainternaTitleFragment on LiferayPaginaInternaHtmlTitle {
    content {
      metaDescription {
        value
      }
      canonicalUrl {
        value
      }
      metaRobots {
        value
      }
      ogImage {
        node {
          resize(width: 1200) {
            src
            width
            height
          }
        }
      }
    }
  }
`;
export const seoShortFormTitleFragment = graphql`
  fragment ShortFormTitleFragment on LiferayShortFormHtmlTitle {
    content {
      metaDescription {
        value
      }
      canonicalUrl {
        value
      }
      metaRobots {
        value
      }
      ogImage {
        node {
          resize(width: 1200) {
            src
            width
            height
          }
        }
      }
    }
  }
`;
export const seoLongFormTitleFragment = graphql`
  fragment LongFormTitleFragment on LiferayLongFormHtmlTitle {
    content {
      metaDescription {
        value
      }
      canonicalUrl {
        value
      }
      metaRobots {
        value
      }
      ogImage {
        node {
          resize(width: 1200) {
            src
            width
            height
          }
        }
      }
    }
  }
`;
export const seoPrivacyTitleFragment = graphql`
  fragment PrivacyTitleFragment on LiferayPaginaPrivacyHtmlTitle {
    content {
      metaDescription {
        value
      }
      canonicalUrl {
        value
      }
      metaRobots {
        value
      }
      ogImage {
        node {
          resize(width: 1200) {
            src
            width
            height
          }
        }
      }
    }
  }
`;
